module.exports = __webpack_public_path__ + "static/media/hall-P5.87cf707a.svg";